import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { LFC } from '../../../Legacy';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { DropButton } from '../../../ui/DropButton';
import { KeepPopoutWidgetOpenButton } from '../../../ui/KeepOpenButton';
import { Tip } from '../../../ui/Tip';
import { useResolve } from '../../Container';
import { useEditorSessionObserver } from '../../canvas/EditorSession';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolInfo } from '../../canvas/tooling/ToolInfo';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { ColorSelector, Colors, toRem } from './../../../ui';
import { eraserTool } from './EraserTool';
import { markerTool } from './MarkerTool';

const StrokeIcon = styled.div<{ size: number | string }>`
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: ${p => toRem(p.size || '1rem')};
        height: ${p => toRem(p.size || '1rem')};
        transform: translate(-50%, -50%);
        background: ${Colors.text};
        border-radius: 50%;
    }
`;

export const MarkerWidget: LFC<{ widget: PopoutWidget }> = ({ widget }) => {

    const dispatch = useResolve(CommandDispatcher);
    const tools = useResolve(ToolManager);
    const activeTool = useEditorSessionObserver(ToolInfo);

    const [color, setColor] = useState(tools.getSetting('markerTool', 'color') || '#ff5722');
    const [size, setSize] = useState(tools.getSetting('markerTool', 'size') || 11);

    const onSelectColor = useCallback((val: string) => {
        setColor(val);
        tools.setSetting('markerTool', 'color', val);
        dispatch(toolEquip, ['markerTool']);
    }, []);

    const onSlideSize = useCallback((val: number) => {
        setSize(val);
        tools.setSetting('markerTool', 'size', val);
        dispatch(toolEquip, ['markerTool']);
    }, []);

    const onEquipEraser = useCallback(() => {
        widget.update({ open: !widget.autoClose });
        dispatch(toolEquip, ['eraserTool']);
    }, [widget.open]);

    return <Flexer flex="column">
        <Flexer flex="row" gap=".375" padding=".5 .5 .375" color={Colors.text}>
            {[3, 7, 11, 15, 19].map(x =>
                <DropButton key={x} padding=".125" overflow=".125" active={activeTool.id === markerTool.id && x === size} onClick={() => onSlideSize(x)}>
                    <StrokeIcon size={1 / 16 * x} />
                </DropButton>
            )}
            <Tip position="top" text="Eraser">
                <DropButton padding=".125" overflow=".125" active={activeTool.id === eraserTool.id} onClick={onEquipEraser} style={{ color: Colors.text }}>
                    <Icon src="deqo://icons/i8/eraser" size="1.5" />
                </DropButton>
            </Tip>
            <KeepPopoutWidgetOpenButton widget={widget} />
        </Flexer>
        <ColorSelector color={color} groups onSelect={onSelectColor} />
    </Flexer>;
};
